export const environment = {
    production: false,
    apiUrl: 'https://2a66-179-94-142-128.ngrok-free.app',
    s3Url: 'https://store-files-beta.scenarioautomation.com',
    name: 'local'
  };